// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3676) return "static/chunks/3676-beb50230cc19691e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "d4fc33f0d6315392" + ".js";
};